import React from 'react';
import './TermsAndConditionsPopup.css';

const defaultTermsAndConditions = `
<p>By submitting your buylist order, you agree to the following terms:</p>
<ol>
  <li><strong>Card Condition:</strong> All cards must match the condition specified in your submission. Cards that do not meet the stated condition may be rejected or offered at a lower price.</li>
  <li><strong>Pricing:</strong> Prices are subject to change based on market conditions. Final prices will be confirmed upon receipt and inspection of your cards.</li>
  <li><strong>Payment:</strong> Payment will be issued after your cards have been received and verified. Cash and store credit payments are processed according to your selection.</li>
  <li><strong>Shipping:</strong> You are responsible for shipping costs and ensuring cards arrive safely. We recommend using tracked and insured shipping for valuable items.</li>
  <li><strong>Returns:</strong> Cards that are rejected may be returned to you at your expense, or donated if you do not wish to pay return shipping.</li>
</ol>
<p>If you have any questions, please contact us before submitting your order.</p>
`;

const TermsAndConditionsPopup = ({ termsAndConditions, onClose }) => {
  // Use custom terms if provided, otherwise use default
  const termsContent = termsAndConditions && termsAndConditions.trim() !== ''
    ? termsAndConditions
    : defaultTermsAndConditions;

  return (
    <div className="popup-overlay">
      <div className="popup-content terms-popup-content">
        <div className="terms-header">
          <h2>Terms and Conditions</h2>
          <button onClick={onClose} className="close-button-x" aria-label="Close">×</button>
        </div>
        <div
          className="terms-content"
          dangerouslySetInnerHTML={{ __html: termsContent }}
        />
        <div className="terms-footer">
          <button onClick={onClose} className="close-button">Close</button>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsPopup;